import { render, staticRenderFns } from "./ModuleGrid.vue?vue&type=template&id=0d2cb108&scoped=true"
import script from "./ModuleGrid.vue?vue&type=script&lang=js"
export * from "./ModuleGrid.vue?vue&type=script&lang=js"
import style0 from "./ModuleGrid.vue?vue&type=style&index=0&id=0d2cb108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2cb108",
  null
  
)

export default component.exports